import { useEffect } from 'react';

/**
 * Wrapper component that forces light mode for its children.
 * Used for public pages like Landing, SignIn, SignUp that should always be light.
 */
export function ForceLightMode({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    const root = document.documentElement;
    const previousClass = root.classList.contains('dark') ? 'dark' : 'light';

    // Force light mode
    root.classList.remove('dark');
    root.classList.add('light');

    // Restore previous theme on unmount
    return () => {
      root.classList.remove('light');
      root.classList.add(previousClass);
    };
  }, []);

  return <>{children}</>;
}
